const history = {
  table: {
    headers: {
      createdBy: 'על ידי',
      createdAt: 'נוצר בתאריך',
      updatedAt: 'עודכן לאחרונה',
      updatedBy: 'על ידי',
      oldValue: 'ערך ישן',
      newValue: 'ערך חדש',
      date: 'תאריך',
      beforeCopy: {
        regular: 'העתק',
        sessionId: 'העתק מזהה מושב',
      },
      afterCopy: 'הועתק',
      field: 'שדה',
      description: 'תיאור',
      by: 'על ידי',
    },
  },
};

export default history;
